<div #myDiv *ngIf="displayValue" class="avatar" [ngClass]="size" [attr.title]="displayTitle">
    {{displayValue.slice(0,3)}}
</div>
